import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthApi from '../api/AuthApi';
import { AuthContext, AuthData } from '../context/auth';

interface Props {
	authData: AuthData;
}

const UnifiedLoginPage = (props: Props) => {
	const location = useLocation();
	const navigate = useNavigate();
	React.useEffect(() => {
		const getAuth = async () => {
			const { authData } = props;
			const status = authData.getAuthStatus();
			const params = new URLSearchParams(location.search);
			const unifiedLoginCode = params.get('code');
			const loginApiUrl = decodeURIComponent(params.get('api'));

			if (loginApiUrl && unifiedLoginCode && status !== 'VALID') {
				const authResponse = await AuthApi.fetchUnifiedLogin(
					loginApiUrl,
					unifiedLoginCode,
				).catch((err) => {
					console.error(err);
					return err;
				});

				if (authResponse.data) {
					const authToken = authResponse.data.auth_token;
					const username = authResponse.data.username;
					const hostName = authResponse.data.hostName;

					if (authToken && username) {
						await authData
							.setAuth(JSON.parse(authToken), username, hostName)
							.catch(() => {
								navigate('home');
							});
					}
				}
			}

			navigate('home');
		};

		getAuth();
	}, []);

	return <CircularProgress />;
};

function withContext(Component: any) {
	return (props: Omit<Props, 'authData'>) => (
		<AuthContext.Consumer>
			{(authData) => <Component {...props} authData={authData} />}
		</AuthContext.Consumer>
	);
}

export default withContext(UnifiedLoginPage);
